// removed by extract-text-webpack-plugin
module.exports = {"starRatingStar":"Star__starRatingStar"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StarRating/components/Star/Star.scss
// module id = 1816
// module chunks = 8